<template>
  <div class="quiz-body">
    <div class="col-left">
      <h1>Level {{level}}</h1>
      <p>Answer correctly at least {{correctAnswersToPassLevel}} questions to unlock the next level.</p>
      <div class="buttons">
        <router-link class="button--submit" :to="`/${$route.params.companySlug}/quizzes/${$route.params.id}/question/${questionsFromThisLevel[0].idQuizQuestion}`">Got it, let’s play!</router-link>
      </div>
    </div>
    <img :src="image">
  </div>
</template>


<script>
export default {
  name: "QuizLevelStart",
  mounted() {
    if(this.$route.name === 'QuizLevelStart') {
      this.$store.dispatch('cleanQuizAnswers')
    }
  },
  computed: {
    image() {
      if(this.level%2 === 0) {
        return '/web/quiz_level_start_even.svg'
      }
      return '/web/quiz_level_start_odd.svg'
    },
    quiz() {
      return this.$store.getters.quiz
    },
    correctAnswersToPassLevel() {
      return this.quiz.correctAnswersToPassLevel[this.level-1]
    },
    level() {
      if(this.$route.name === 'QuizLevelStart') {
        return 1
      }
      return this.$route.params.level
    },
    questionsFromThisLevel() {
      return this.quiz._embedded.Questions.filter(question => {
        return question.level === Number(this.level)
      })
    },
  }
}
</script>
